import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { closeDonateModal, closeModal, openDonateModal } from "../../store/modal"
import style from "./Modal.module.scss"
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useForm } from "react-hook-form";

const isValidEmail = email =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );

export const JoinBetaModal = () => {
  const isModalOpen = useSelector((state => state.modal.isModalOpen))
  const dispath = useDispatch()
  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  useEffect(() => {
    if (isModalOpen) {
      document.querySelector('body').classList.add('lock')
    } else {
      document.querySelector('body').classList.remove('lock')
    }
  })

  const handleEmailValidation = email => {
    console.log("ValidateEmail was called with", email);

    const isValid = isValidEmail(email);

    const validityChanged =
      (errors.email && isValid) || (!errors.email && !isValid);
    if (validityChanged) {
      console.log("Fire tracker with", isValid ? "Valid" : "Invalid");
    }

    return isValid;
  };

  const validateModalForm = (data) => {
    console.log(data);
    // e.preventDefault()
    let formData = new FormData(document.querySelector(".modal-form"))

    let xhr = new XMLHttpRequest()

    dispath(openDonateModal())

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log('Mail send')
        }
      }
    }

    xhr.open('POST', 'mail.php', true)
    xhr.send(formData)
  }

  return (
    <>
      <div className={`
      ${style.modal} 
      ${style.modal_main} 
      ${isModalOpen ? style.active : ''}
      `}>
        <div
          onClick={() => dispath(closeModal())}
          className={`${style.modal__bg} ${style.modal_main__bg}`}>

        </div>
        <div className={style.modal__content}>
          <div
            onClick={() => dispath(closeModal())}
            className={`${style.modal__close} ${style._modal_mainCloseBtn}`}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
                fill="black" />
            </svg>
          </div>

          <div className={style.modal__title}>
            Присоединяйтесь к бета-тестированию
          </div>
          <div className={style.modal__desc}>
            В данный момент сервис тестируется с реальными пациентами и стоматологами. Команда Fredemo постепенно расширяет количество пользователей, добавляя новые регионы.
            <br />
            Оставьте заявку на участие в бета-тестировании, и как только Ваш регион будет добавлен, мы сообщим Вам на почту.
          </div>
          <form action="#" onSubmit={handleSubmit(validateModalForm)} className={`modal-form ${style.modalForm}`}>
            <div className={style.modalForm__inputs}>
              <label className={`${style.modalForm__inputsItem} modal-form__inputs-item`}>
                <input
                  {...register("email", {
                    required: true,
                    minLength: 3,
                    validate: handleEmailValidation
                  })}
                  type="text" name="email" placeholder="Name@mail.ru" className={`${style.inputEmail} input-email`} />
                {errors.email && <span className={style._err}>Введите свой email</span>}
              </label>
              <label className={`${style.modalForm__inputsItem} modal-form__inputs-item`}>
                <input
                  {...register("city", { required: true, minLength: 2 })}
                  type="text" name="city" placeholder="Москва"
                  className={`${style.inputCity} input-city`} />
                {errors.city && <span className={style._err}>Введите город</span>}
              </label>
            </div>
            <button
              type="submit"
              // onClick={(e) => validateModalForm(e)}
              className={`${style.modalForm__btn}  btn ${style._modalContinueBtn}`}>
              Хочу Fredomo
            </button>
          </form>
          <div className={style.modal__start}>
            Полное открытие Fredemo для всех стран СНГ <br /> ожидается в начале 2023 г.
          </div>
          <div className={style.modalLinks}>
            <a href="https://instagram.com/fredemoapp?igshid=YmMyMTA2M2Y=" className={style.modalLinks__item}>
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"
                  fill="black" />
                <mask id="mask0_36_2341" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="26"
                  height="26">
                  <path fillRule="evenodd" clipRule="evenodd"
                    d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"
                    fill="white" />
                </mask>
                <g mask="url(#mask0_36_2341)">
                  <path fillRule="evenodd" clipRule="evenodd"
                    d="M13.0006 6.06665C11.1176 6.06665 10.8813 6.07488 10.1418 6.10854C9.40364 6.14234 8.89981 6.2592 8.45896 6.43065C8.00295 6.60774 7.61612 6.84464 7.23074 7.23016C6.84507 7.61554 6.60818 8.00237 6.43051 8.45824C6.25862 8.89924 6.14162 9.40321 6.1084 10.141C6.07532 10.8806 6.06665 11.1171 6.06665 13.0001C6.06665 14.8831 6.07503 15.1186 6.10854 15.8582C6.14248 16.5963 6.25934 17.1002 6.43065 17.541C6.60789 17.997 6.84478 18.3838 7.23031 18.7692C7.61554 19.1549 8.00237 19.3924 8.4581 19.5695C8.89924 19.7409 9.40321 19.8578 10.1412 19.8916C10.8807 19.9252 11.1169 19.9335 12.9998 19.9335C14.8829 19.9335 15.1185 19.9252 15.8581 19.8916C16.5962 19.8578 17.1006 19.7409 17.5417 19.5695C17.9976 19.3924 18.3838 19.1549 18.7691 18.7692C19.1548 18.3838 19.3916 17.997 19.5693 17.5411C19.7398 17.1002 19.8568 16.5962 19.8914 15.8584C19.9246 15.1188 19.9333 14.8831 19.9333 13.0001C19.9333 11.1171 19.9246 10.8807 19.8914 10.1412C19.8568 9.40306 19.7398 8.89924 19.5693 8.45839C19.3916 8.00237 19.1548 7.61554 18.7691 7.23016C18.3834 6.84449 17.9977 6.6076 17.5413 6.43065C17.0993 6.2592 16.5952 6.14234 15.8571 6.10854C15.1175 6.07488 14.882 6.06665 12.9985 6.06665H13.0006ZM12.3787 7.31608C12.4995 7.3159 12.6294 7.31595 12.7696 7.31602L13.0007 7.31608C14.8519 7.31608 15.0713 7.32273 15.8024 7.35595C16.4784 7.38686 16.8453 7.49982 17.0897 7.59472C17.4132 7.72039 17.6439 7.87061 17.8864 8.11328C18.1291 8.35595 18.2793 8.58706 18.4053 8.91062C18.5002 9.15474 18.6133 9.52163 18.644 10.1976C18.6773 10.9285 18.6845 11.1481 18.6845 12.9984C18.6845 14.8488 18.6773 15.0684 18.644 15.7992C18.6131 16.4753 18.5002 16.8421 18.4053 17.0863C18.2796 17.4098 18.1291 17.6402 17.8864 17.8827C17.6437 18.1254 17.4134 18.2756 17.0897 18.4013C16.8455 18.4966 16.4784 18.6093 15.8024 18.6402C15.0715 18.6734 14.8519 18.6807 13.0007 18.6807C11.1493 18.6807 10.9299 18.6734 10.199 18.6402C9.523 18.609 9.15611 18.4961 8.91156 18.4012C8.588 18.2755 8.35689 18.1253 8.11422 17.8826C7.87155 17.6399 7.72132 17.4094 7.59537 17.0857C7.50047 16.8416 7.38737 16.4747 7.3566 15.7987C7.32338 15.0678 7.31673 14.8482 7.31673 12.9967C7.31673 11.1452 7.32338 10.9268 7.3566 10.1959C7.38751 9.5199 7.50047 9.153 7.59537 8.9086C7.72104 8.58504 7.87155 8.35393 8.11422 8.11126C8.35689 7.86859 8.588 7.71837 8.91156 7.59241C9.15596 7.49707 9.523 7.38441 10.199 7.35335C10.8386 7.32446 11.0865 7.3158 12.3787 7.31435V7.31608ZM15.8697 9.29905C15.8697 8.83957 16.2423 8.46733 16.7017 8.46733V8.46705C17.161 8.46705 17.5337 8.83972 17.5337 9.29905C17.5337 9.75839 17.161 10.1311 16.7017 10.1311C16.2423 10.1311 15.8697 9.75839 15.8697 9.29905ZM13.0005 9.43943C11.0342 9.4395 9.44002 11.0337 9.44002 13C9.44002 14.9664 11.0343 16.5599 13.0006 16.5599C14.967 16.5599 16.5606 14.9664 16.5606 13C16.5606 11.0337 14.9668 9.43943 13.0005 9.43943ZM15.3117 13.0001C15.3117 11.7236 14.2769 10.6889 13.0006 10.6889C11.7241 10.6889 10.6895 11.7236 10.6895 13.0001C10.6895 14.2764 11.7241 15.3112 13.0006 15.3112C14.2769 15.3112 15.3117 14.2764 15.3117 13.0001Z"
                    fill="white" />
                </g>
              </svg>
            </a>
            <a href="https://t.me/fredemo" className={style.modalLinks__item}>
              <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M0.75 13C0.75 20.1797 6.5703 26 13.75 26C20.9297 26 26.75 20.1797 26.75 13C26.75 5.8203 20.9297 0 13.75 0C6.5703 0 0.75 5.8203 0.75 13ZM11.3666 18.9583L11.5878 15.6445L11.5876 15.6444L17.6158 10.2044C17.8804 9.96965 17.558 9.85515 17.2068 10.0681L9.76724 14.7617L6.55375 13.7587C5.85978 13.5462 5.85479 13.0693 6.70956 12.7265L19.2318 7.89796C19.8037 7.6383 20.3557 8.03532 20.1374 8.91068L18.0049 18.96C17.856 19.6741 17.4245 19.8449 16.8266 19.515L13.5781 17.115L12.0166 18.6333C12.0117 18.6381 12.0068 18.6429 12.0019 18.6476C11.8273 18.8177 11.6828 18.9583 11.3666 18.9583Z"
                  fill="black" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export const DonateModal = () => {
  const isModalOpen = useSelector((state => state.modal.isDonateModalOpen))
  const dispath = useDispatch()

  const showTooltip = (num) => {
    const tooltip = document.querySelector(`._tooltip-${num}`)
    tooltip.classList.add(style.show)
    setTimeout(() => {
      tooltip.classList.remove(style.show)
    }, 1500);
  }

  useEffect(() => {
    setTimeout(() => {
      if (isModalOpen) {
        document.querySelector('body').classList.add('lock')
      } else {
        document.querySelector('body').classList.remove('lock')
      }
    }, 1);
  })

  return (
    <div className={`
    ${style.modal} 
    ${style.modal_donate}
    ${isModalOpen ? style.active : ''}
        `}>
      <div
        onClick={() => dispath(closeDonateModal())}
        className={`${style.modal__bg} ${style.modal_donate__bg}`}>

      </div>
      <div className={style.modal__content}>
        <div
          onClick={() => dispath(closeDonateModal())}
          className={`${style.modal__close} ${style._modalCloseBtn} ${style._modal_donateCloseBtn} `}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
              fill="black" />
          </svg>
        </div>
        <div className={style.modal__title}>
          Отправьте донат, чтобы ускорить релиз
        </div>
        <div className={style.modal__desc}>
          Если Вы тоже считаете, что Fredemo должно выйти как можно скорее, Вы можете помочь символической суммой. <br />
          Несмотря на то, что само приложение уже разработано, привлечение стоматологов требует человеческого ресурса. <br />
          Ваша помощь позволит проекту Fredemo скорее выйти в свет.
        </div>
        <div className={style.modalAccounts}>
          <div className={style.modalAccounts__item}>
            <div className={style.modalAccounts__itemName}>USDT TRC20</div>
            <div data-clipboard-target="#usdtAcc" className={`${style.modalAccounts__itemContent} ${style._copyUsdtacc} `} title="Скопировать">
              <span className={`${style._tooltip} _tooltip-1`}>
                Скопировано!
              </span>
              {/* TYdsrxJFfjTBcuq5E1GvC2vN8gjU9iP8pm */}

              <CopyToClipboard text={`TYdsrxJFfjTBcuq5E1GvC2vN8gjU9iP8pm`}
                onCopy={() => showTooltip(1)}>
                <span>TYdsrxJFfjTBcuq5E1GvC2vN8gjU9iP8pm</span>
              </CopyToClipboard>

              {/* <input type="text" value="TYdsrxJFfjTBcuq5E1GvC2vN8gjU9iP8pm" id="usdtAcc" /> */}
            </div>
          </div>
          <div className={style.modalAccounts__item}>
            <div className={style.modalAccounts__itemName}>BTC</div>
            <div data-clipboard-target="#btcAcc" className={`${style.modalAccounts__itemContent} ${style._copyBtcacc} `} title="Скопировать">
              <span className={`${style._tooltip} _tooltip-2`}>
                Скопировано!
              </span>
              <CopyToClipboard text={`1BYDHG7fY7aGEuL2CS7WeoqXWFQA6XFQJQ`}
                onCopy={() => showTooltip(2)}>
                <span>1BYDHG7fY7aGEuL2CS7WeoqXWFQA6XFQJQ</span>
              </CopyToClipboard>
              {/* 1BYDHG7fY7aGEuL2CS7WeoqXWFQA6XFQJQ
              <input type="text" value="1BYDHG7fY7aGEuL2CS7WeoqXWFQA6XFQJQ" id="btcAcc" /> */}
            </div>
          </div>
          <div className={style.modalAccounts__item}>
            <div className={style.modalAccounts__itemName}>Тинькофф</div>
            <div data-clipboard-target="#tinkoffAcc" className={`${style.modalAccounts__itemContent} ${style._copyTinkoffacc} `}
              title="Скопировать">
              <span className={`${style._tooltip} _tooltip-3`}>
                Скопировано!
              </span>
              <CopyToClipboard text={`5536913813314321`}
                onCopy={() => showTooltip(3)}>
                <span>5536 9138 1331 4321</span>
              </CopyToClipboard>
              {/* 5536 9138 1331 4321
              <input type="text" value="5536913813314321" id="tinkoffAcc" /> */}
            </div>
          </div>
        </div>
        <div className={style.modalLinks}>
          <a href="https://instagram.com/fredemoapp?igshid=YmMyMTA2M2Y=" className={style.modalLinks__item}>
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"
                fill="black" />
              <mask id="mask0_36_2341" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="26"
                height="26">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"
                  fill="white" />
              </mask>
              <g mask="url(#mask0_36_2341)">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M13.0006 6.06665C11.1176 6.06665 10.8813 6.07488 10.1418 6.10854C9.40364 6.14234 8.89981 6.2592 8.45896 6.43065C8.00295 6.60774 7.61612 6.84464 7.23074 7.23016C6.84507 7.61554 6.60818 8.00237 6.43051 8.45824C6.25862 8.89924 6.14162 9.40321 6.1084 10.141C6.07532 10.8806 6.06665 11.1171 6.06665 13.0001C6.06665 14.8831 6.07503 15.1186 6.10854 15.8582C6.14248 16.5963 6.25934 17.1002 6.43065 17.541C6.60789 17.997 6.84478 18.3838 7.23031 18.7692C7.61554 19.1549 8.00237 19.3924 8.4581 19.5695C8.89924 19.7409 9.40321 19.8578 10.1412 19.8916C10.8807 19.9252 11.1169 19.9335 12.9998 19.9335C14.8829 19.9335 15.1185 19.9252 15.8581 19.8916C16.5962 19.8578 17.1006 19.7409 17.5417 19.5695C17.9976 19.3924 18.3838 19.1549 18.7691 18.7692C19.1548 18.3838 19.3916 17.997 19.5693 17.5411C19.7398 17.1002 19.8568 16.5962 19.8914 15.8584C19.9246 15.1188 19.9333 14.8831 19.9333 13.0001C19.9333 11.1171 19.9246 10.8807 19.8914 10.1412C19.8568 9.40306 19.7398 8.89924 19.5693 8.45839C19.3916 8.00237 19.1548 7.61554 18.7691 7.23016C18.3834 6.84449 17.9977 6.6076 17.5413 6.43065C17.0993 6.2592 16.5952 6.14234 15.8571 6.10854C15.1175 6.07488 14.882 6.06665 12.9985 6.06665H13.0006ZM12.3787 7.31608C12.4995 7.3159 12.6294 7.31595 12.7696 7.31602L13.0007 7.31608C14.8519 7.31608 15.0713 7.32273 15.8024 7.35595C16.4784 7.38686 16.8453 7.49982 17.0897 7.59472C17.4132 7.72039 17.6439 7.87061 17.8864 8.11328C18.1291 8.35595 18.2793 8.58706 18.4053 8.91062C18.5002 9.15474 18.6133 9.52163 18.644 10.1976C18.6773 10.9285 18.6845 11.1481 18.6845 12.9984C18.6845 14.8488 18.6773 15.0684 18.644 15.7992C18.6131 16.4753 18.5002 16.8421 18.4053 17.0863C18.2796 17.4098 18.1291 17.6402 17.8864 17.8827C17.6437 18.1254 17.4134 18.2756 17.0897 18.4013C16.8455 18.4966 16.4784 18.6093 15.8024 18.6402C15.0715 18.6734 14.8519 18.6807 13.0007 18.6807C11.1493 18.6807 10.9299 18.6734 10.199 18.6402C9.523 18.609 9.15611 18.4961 8.91156 18.4012C8.588 18.2755 8.35689 18.1253 8.11422 17.8826C7.87155 17.6399 7.72132 17.4094 7.59537 17.0857C7.50047 16.8416 7.38737 16.4747 7.3566 15.7987C7.32338 15.0678 7.31673 14.8482 7.31673 12.9967C7.31673 11.1452 7.32338 10.9268 7.3566 10.1959C7.38751 9.5199 7.50047 9.153 7.59537 8.9086C7.72104 8.58504 7.87155 8.35393 8.11422 8.11126C8.35689 7.86859 8.588 7.71837 8.91156 7.59241C9.15596 7.49707 9.523 7.38441 10.199 7.35335C10.8386 7.32446 11.0865 7.3158 12.3787 7.31435V7.31608ZM15.8697 9.29905C15.8697 8.83957 16.2423 8.46733 16.7017 8.46733V8.46705C17.161 8.46705 17.5337 8.83972 17.5337 9.29905C17.5337 9.75839 17.161 10.1311 16.7017 10.1311C16.2423 10.1311 15.8697 9.75839 15.8697 9.29905ZM13.0005 9.43943C11.0342 9.4395 9.44002 11.0337 9.44002 13C9.44002 14.9664 11.0343 16.5599 13.0006 16.5599C14.967 16.5599 16.5606 14.9664 16.5606 13C16.5606 11.0337 14.9668 9.43943 13.0005 9.43943ZM15.3117 13.0001C15.3117 11.7236 14.2769 10.6889 13.0006 10.6889C11.7241 10.6889 10.6895 11.7236 10.6895 13.0001C10.6895 14.2764 11.7241 15.3112 13.0006 15.3112C14.2769 15.3112 15.3117 14.2764 15.3117 13.0001Z"
                  fill="white" />
              </g>
            </svg>
          </a>
          <a href="https://t.me/fredemo" className={style.modalLinks__item}>
            <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd"
                d="M0.75 13C0.75 20.1797 6.5703 26 13.75 26C20.9297 26 26.75 20.1797 26.75 13C26.75 5.8203 20.9297 0 13.75 0C6.5703 0 0.75 5.8203 0.75 13ZM11.3666 18.9583L11.5878 15.6445L11.5876 15.6444L17.6158 10.2044C17.8804 9.96965 17.558 9.85515 17.2068 10.0681L9.76724 14.7617L6.55375 13.7587C5.85978 13.5462 5.85479 13.0693 6.70956 12.7265L19.2318 7.89796C19.8037 7.6383 20.3557 8.03532 20.1374 8.91068L18.0049 18.96C17.856 19.6741 17.4245 19.8449 16.8266 19.515L13.5781 17.115L12.0166 18.6333C12.0117 18.6381 12.0068 18.6429 12.0019 18.6476C11.8273 18.8177 11.6828 18.9583 11.3666 18.9583Z"
                fill="black" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  )
}
